module.exports = __webpack_public_path__ + "img/5.e7edbc92.jpg";